import Plyr from 'plyr';

export default class Video {
	constructor() {
		this.init();
	}

	init() {
		new Plyr('#player', {
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
			youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
		});
	}
}
